import { usePathname } from 'next/navigation';
import { useRouter } from 'next/router';
import { useQuery } from 'react-query';

import { getExperimentVariantOnClient } from '../utils';

export function useClientExperiment(
  flagKey: string,
  { enabled = true, pathRegex }: { enabled?: boolean; pathRegex?: RegExp } = {}
) {
  const router = useRouter();
  const isForced = Boolean(router.query.forcedClientExperiment);
  const pathname = usePathname();
  const isEnabledOnPath = pathRegex ? pathRegex.test(pathname) : true;
  const { isLoading, data: variant } = useQuery(
    ['clientExperiment', flagKey],
    () => {
      return getExperimentVariantOnClient({ flagKey });
    },
    { enabled: enabled && isEnabledOnPath && !isForced }
  );

  if (isForced && typeof router.query.forcedClientExperiment === 'string') {
    const [experimentKey, variantKey] = router.query.forcedClientExperiment.split('--');
    if (experimentKey === flagKey) {
      return { variant: variantKey, isLoading: false };
    }
  }

  return { isLoading, variant };
}
